<section class="content m-0 trouble-signup-page auth-page auth-page-narrow">
  <div class="row m-0 py-2 trouble-signup-row">
    <div class="col-12 px-0 trouble-signup-header">
      <h1 class="title">Trouble signing up?</h1>
    </div>

    <div class="col-12 px-0">
      <p class="sub-title">Tell us what happened and our team will help.</p>

      <div
        *ngIf="successMessage"
        class="alert alert-success mb-4"
        role="status"
      >
        {{ successMessage }}
      </div>
      <div *ngIf="errorMessage" class="alert alert-danger mb-4" role="alert">
        {{ errorMessage }}
      </div>

      <form
        #troubleSignupForm="ngForm"
        class="trouble-signup-form needs-validation"
        (ngSubmit)="submit(troubleSignupForm)"
        novalidate
      >
        <div class="form-group trouble-signup-field">
          <label for="troubleFullName">
            Full name <span class="text-danger">*</span>
          </label>
          <input
            id="troubleFullName"
            type="text"
            class="form-control"
            name="fullName"
            [(ngModel)]="troubleSignupDTO.fullName"
            required
            maxlength="100"
            autocomplete="name"
            #fullName="ngModel"
            [class.is-invalid]="submitted && fullName.invalid"
          />
          <div *ngIf="submitted && fullName.invalid" class="invalid-feedback">
            <span *ngIf="fullName.errors?.['required']"
              >Full name is required.</span
            >
            <span *ngIf="fullName.errors?.['maxlength']">
              Full name must be 100 characters or fewer.
            </span>
          </div>
        </div>

        <div class="form-group trouble-signup-field">
          <label for="troubleEmail">
            Email <span class="text-danger">*</span>
          </label>
          <input
            id="troubleEmail"
            type="email"
            class="form-control"
            name="email"
            [(ngModel)]="troubleSignupDTO.email"
            required
            email
            autocomplete="email"
            #email="ngModel"
            [class.is-invalid]="submitted && email.invalid"
          />
          <div *ngIf="submitted && email.invalid" class="invalid-feedback">
            <span *ngIf="email.errors?.['required']">Email is required.</span>
            <span *ngIf="email.errors?.['email']"
              >Enter a valid email address.</span
            >
          </div>
        </div>

        <div class="form-group trouble-signup-field">
          <label for="troublePhone"
            >Phone number <span class="optional">(optional)</span></label
          >
          <input
            id="troublePhone"
            type="tel"
            class="form-control"
            name="phone"
            [(ngModel)]="troubleSignupDTO.phone"
            pattern="^[0-9]{10}$"
            mask="(000) 000-0000"
            inputmode="tel"
            autocomplete="tel"
            minlength="10"
            #phone="ngModel"
            [class.is-invalid]="submitted && phone.invalid"
          />
          <div *ngIf="submitted && phone.invalid" class="invalid-feedback">
            Enter a 10 digit phone number.
          </div>
        </div>

        <div class="form-group trouble-signup-field">
          <label for="troubleIssue">
            Describe the issue you are facing <span class="text-danger">*</span>
          </label>
          <textarea
            id="troubleIssue"
            class="form-control"
            name="issue"
            [(ngModel)]="troubleSignupDTO.issue"
            required
            rows="5"
            #issue="ngModel"
            [class.is-invalid]="submitted && issue.invalid"
          ></textarea>
          <div *ngIf="submitted && issue.invalid" class="invalid-feedback">
            Describe the issue so we can help.
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-black w-100 trouble-signup-submit"
          [disabled]="isSubmitting"
        >
          <span *ngIf="!isSubmitting">Send request</span>
          <span *ngIf="isSubmitting" class="d-inline-flex align-items-center">
            <span
              class="citizex-spinner citizex-spinner--sm mr-2"
              aria-hidden="true"
            ></span>
            Sending...
          </span>
        </button>
      </form>

      <p class="trouble-signup-cancel text-center mb-0">
        <a
          [routerLink]="['/signup']"
          class="btn btn-link btn-link-theme font-14 p-0"
        >
          Back to sign up
        </a>
      </p>
    </div>
  </div>
</section>
